import { HelpFactoryComponent, SortableList } from '@/components/common';
import { EventTable } from '@/components/event';
import { HelpFeature } from '@/model/HelpModel';
import { UpOutlined } from '@ant-design/icons';
import { Collapse, Space } from 'antd';
import React, { useState } from 'react';
import './eventTableWidget.scss';

const { Panel } = Collapse;

// Normal properties for the component
interface OwnProps {}

// combine them together
type Props = OwnProps;

const topicId: string = 'Events';

const EventTableWidget: React.FC = (props: Props) => {
	//#region State Management Variables
	const [isExpanded, setIsExpanded] = useState<boolean>(true);
	//#endregion

	let content: React.ReactElement = <></>;
	if (isExpanded) {
		content = <EventTable />;
	}

	return (
		<div className='event-viewer-widget-container'>
			<Collapse
				bordered={true}
				defaultActiveKey={'1'}
				expandIconPosition='end'
				expandIcon={({ isActive }) => (
					<Space size={14}>
						<span
							onClick={e => {
								e.stopPropagation();
								e.preventDefault();
							}}>
							<HelpFactoryComponent helpFeature={HelpFeature.StatusDashboard} topicId={topicId} size='medium' />
						</span>
						<UpOutlined rotate={isActive ? 180 : 0} />
					</Space>
				)}
				onChange={(keys: string[]) => {
					setIsExpanded(keys.length === 1);
				}}
				className={'status-widget-collapse'}>
				<Panel
					id='statusDashboardEventTableWidget'
					key='1'
					header={<SortableList.DragHandle className='status-dashboard-widget-panel-header-title'>{_('Events')}</SortableList.DragHandle>}
					className='status-widget status-widget-collapse-content'>
					{content}
				</Panel>
			</Collapse>
		</div>
	);
};

export { EventTableWidget };
